<template>
  <div class="not-found">
    <p>Not Found / Error 404</p>
    <a @click="$router.go(-1)"> {{ $t('message.notfound.volver') }} </a>
  </div>
</template>

<script>
export default {
  name: 'not-found',
  data() {
    return {};
  }
};
</script>

<style scoped>
.not-found a {
  cursor: pointer;
}
</style>
